export const GET_SERVICE_LINE_LISTING = "GET_SERVICE_LINE_LISTING";
export const GET_SERVICE_LISTING = "GET_SERVICE_LISTING";
export const GET_SERVICE_LINE_DETAILS = "GET_SERVICE_LINE_DETAILS";
export const GET_SERVICE_DETAILS = "GET_SERVICE_DETAILS";
export const SERVICE_FORM_DATA = "SERVICE_FORM_DATA";
export const GET_FREQUENCY_FOR_CHILD = "GET_FREQUENCY_FOR_CHILD";
